export default {
    LOAD_GROUP(state, group) {
        state.items = group
    }
}